var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi:eye-off",
    clipPath: "url(#clip0_3740_431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.07508 4.38702C9.70605 4.23932 10.3521 4.16549 11.0001 4.16702C17.4167 4.16702 21.0834 11.5003 21.0834 11.5003C20.527 12.5413 19.8634 13.5214 19.1034 14.4245M12.9434 13.4437C12.6917 13.7139 12.3881 13.9306 12.0507 14.0809C11.7134 14.2312 11.3492 14.312 10.98 14.3185C10.6108 14.325 10.244 14.2571 9.90156 14.1188C9.55913 13.9805 9.24808 13.7746 8.98694 13.5135C8.72581 13.2524 8.51994 12.9413 8.38163 12.5989C8.24332 12.2564 8.1754 11.8897 8.18191 11.5204C8.18843 11.1512 8.26925 10.787 8.41955 10.4497C8.56986 10.1124 8.78656 9.80878 9.05675 9.55702M16.4451 16.9453C14.8781 18.1398 12.9701 18.8015 11.0001 18.8337C4.58342 18.8337 0.916748 11.5003 0.916748 11.5003C2.05698 9.37542 3.63846 7.51891 5.55508 6.05535L16.4451 16.9453Z",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.916748 1.41699L21.0834 21.5837",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3740_431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.7ae11780ccf744af9e3cf86acc649075.svg";
export { ForwardRef as ReactComponent };